































import Vue from 'vue';
import {
  Component, Inject, Prop, Watch,
} from 'vue-property-decorator';
import UserResource from '@/api/user/UserResource';
import { User } from '@/api/user/User';

@Component({ name: 'user-selector' })
export default class UserSelector extends Vue {
	@Inject('UserResource')
	private userResource!: UserResource;

	@Prop()
	value!: User | User[] | null;

	@Prop({ default: 'User' })
	label?: string;

	@Prop({ default: false })
	includeBlankValue?: boolean;

	@Prop({ default: 'No User' })
	unassignedUserDisplayName?: string;

	@Prop({ default: true }) readonly dense!: boolean;

	@Prop({ default: false }) readonly multiple!: boolean;

	@Prop({ default: false }) readonly hideDetails!: boolean;

	selected: User | User[] | null = null;

	errorMessage: string = '';

	users: User[] = [];

	loading: boolean = false;

	mounted() {
	  this.loadUsers();
	  this.onExternalValueChange();
	}

	loadUsers() {
	  this.userResource
	    .getAll()
	    .then((result: User[]) => {
	      const filteredUsers : User[] = [];
	      for (let i = 0; i < result.length; i++) {
	        const user = result[i];
	        if (!UserSelector.isEmpty(user.firstName) || !UserSelector.isEmpty(user.lastName)) {
	          filteredUsers.push(result[i]);
	        }
	      }

	      for (let i = 0; i < filteredUsers.length; i++) {
	        const user: User = filteredUsers[i];

	        user.displayName = UserSelector.getFriendlyDisplayName(
	          user.firstName,
	          user.lastName,
	        );
	      }

	      filteredUsers.sort((u1, u2) => {
	        if (u1 === u2) {
	          return 0;
	        }
	        if (!u1) {
	          return -1;
	        }
	        if (!u2) {
	          return 1;
	        }
	        const d1: string = (u1.displayName ? u1.displayName : '').trim().toLocaleLowerCase();
	        const d2: string = (u2.displayName ? u2.displayName : '').trim().toLocaleLowerCase();
	        return d1.localeCompare(d2);
	      });

	      if (this.includeBlankValue) {
	        filteredUsers.unshift(this.unassignedUser());
	      }

	      this.users = filteredUsers;
	      this.loading = false;
	      this.errorMessage = '';
	    })
	    .catch((error: any) => {
	      // if (error.response.status !== 401) {
	      console.log(error);
	      this.errorMessage =	'An unexpected error occurred while attempting to fetch  users.';
	      // }
	    });
	}

	static getFriendlyDisplayName(firstName: string, lastName: string) {
	  let friendlyDisplayName: string = '';
	  if (!UserSelector.isEmpty(firstName)) {
	    friendlyDisplayName = firstName.replace(',', ' ');
	  }

	  if (!UserSelector.isEmpty(lastName)) {
	    if (!UserSelector.isEmpty(firstName)) {
	      friendlyDisplayName = friendlyDisplayName.concat(' ');
	    }
	    friendlyDisplayName = friendlyDisplayName.concat(lastName);
	  }

	  return friendlyDisplayName;
	}

	static isEmpty(str: String) {
	  return !str || str.length === 0;
	}

	unassignedUser() {
	  return {
	    id: null,
	    firstName: '',
	    lastName: '',
	    displayName: this.unassignedUserDisplayName || '',
	  };
	}

	updateSelection(newValue: any) {
	  this.selected = newValue;
	  this.$emit('input', this.selected);
	}

	@Watch('value')
	onExternalValueChange() {
	  this.selected = this.value;
	}
}
